import { connect } from 'react-redux';
import { _getNotice } from '@/actions/noticeAction';

import Background from '@/components/common/Background';

export default connect(
  state => ({
    
  }),
  {
    _getNotice
  }
)(Background);


// WEBPACK FOOTER //
// ./src/containers/common/BackgroundContainer.js